import type { PageHead } from '@ketvietlab/ketjs-view-tools'
import type { ContentPage } from './model.ts'
export const origin = 'https://ketviet.vn'
export function pageHead(route: string, page?: ContentPage): PageHead {
  const title = `${page?.title ?? 'Không tìm thấy bài viết'} | Trợ giúp Két Việt`
  const description = page?.description ?? 'Tìm hướng dẫn trong trung tâm trợ giúp Két Việt.'
  return { title, description, lang: 'vi', scripts: [{ src: '/help/theme-init.js' }],
    links: [{ rel: 'canonical', href: origin + route }, { rel: 'icon', href: '/help/logo-light.png' }],
    meta: [{ name: 'robots', content: route.includes('/404/') ? 'noindex,follow' : 'index,follow' }, { property: 'og:title', content: title }, { property: 'og:description', content: description }, { property: 'og:url', content: origin + route }, { property: 'og:locale', content: 'vi_VN' }],
    structuredData: [{ '@context': 'https://schema.org', '@type': 'Article', headline: page?.title, description, inLanguage: 'vi', url: origin + route, publisher: { '@type': 'Organization', name: 'Két Việt' } }],
  }
}
export function updatePageHead(page: ContentPage) {
  const head = pageHead(page.route, page)
  document.title = head.title
  document.querySelector('meta[name="description"]')?.setAttribute('content', head.description!)
  document.querySelector('link[rel="canonical"]')?.setAttribute('href', origin + page.route)
  for (const meta of head.meta ?? []) if (meta.property) document.querySelector(`meta[property="${meta.property}"]`)?.setAttribute('content', meta.content)
  for (const node of document.querySelectorAll('script[type="application/ld+json"]')) node.textContent = JSON.stringify(head.structuredData?.[0])
}
